module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Plus-ab725ed6bd2f1f6719afcf9703825a24.svg";